import React from 'react';
import { siteConfig } from '../config/siteConfig';
import ScrollingTitle from '../components/ScrollingTitle/ScrollingTitle';
import FestivalAccordion from '../components/FestivalAccordion/FestivalAccordion';
import './Page.css';

const About = () => {
  const { about } = siteConfig;

  return (
    <div className="about-page">
      <ScrollingTitle lines={about.title.lines} />
      
      <div className="page-container about-content">
        <div className="page-content">
          <div className="content-section about-main">
            <p className="about-description">{about.content.description}</p>
            <p className="about-cta">{about.content.callToAction}</p>
          </div>
        </div>
      </div>

      <div className="about-festivals-section">
        <FestivalAccordion />
      </div>
    </div>
  );
};

export default About; 